import { render } from "./CarouselTemplate.vue?vue&type=template&id=06307123&scoped=true"
import script from "./CarouselTemplate.vue?vue&type=script&lang=js"
export * from "./CarouselTemplate.vue?vue&type=script&lang=js"

import "./CarouselTemplate.vue?vue&type=style&index=0&id=06307123&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-06307123"

export default script